export default "__VITE_ASSET__274c8cbe__"